// Whether About this project was opened by its own link, so closing it steps Back to the home
// instead of adding a history entry; opened by a link or a reload, it closes in place. Which
// About button opened it, so focus goes back there (the buttons hide while it is open).
export type AboutOpener = 'inline' | 'bar';
let pushed = false;
let opener: AboutOpener | null = null;

export function aboutOpened(from: AboutOpener) {
  pushed = true;
  opener = from;
}

/** Whether the open panel was pushed by its link; the answer is used once. */
export function takeAboutPushed() {
  const was = pushed;
  pushed = false;
  return was;
}

/** The About button that opened the panel, if one did; the answer is used once. */
export function takeAboutOpener() {
  const was = opener;
  opener = null;
  return was;
}
